import { Component, OnInit } from '@angular/core';
import { Status } from 'src/app/model/changelogs/changelogs';
import { ChangelogsService } from 'src/app/services/http/changelogs/changelogs.service';


@Component({
  selector: 'app-changelogs',
  templateUrl: './changelogs.component.html',
  styleUrls: ['./changelogs.component.scss']
})
export class ChangelogsComponent implements OnInit {

  constructor(private service : ChangelogsService) { }

  public status !: Status[];
  public uiVersion: string = require('../../../../package.json').version;
  public apiVersion !: string;

  ngOnInit(): void {

    this.service.getApiVersion()
    .subscribe( 
      (version) => {
        this.apiVersion = version[0].version;
        console.log(this.apiVersion);
        console.log(version);
      });
    
    this.service.getStatusData()
    .subscribe( 
      (status) => {
        this.status = status;
      });
    


    
  }

}
